import * as XLSX from "xlsx";

const ExportUsersButton = ({ users = [] }) => {
  const exportToExcel = () => {
    if (!Array.isArray(users) || users.length === 0) {
      alert("No hay usuarios para exportar");
      return;
    }

    const filteredData = users.map(
      ({
        name,
        cedula,
        email,
        age,
        phone,
        score,
        date_inscription,
        total_hits,
        partial_hits,
      }) => ({
        Nombre: name ?? "",
        Cedula: cedula ?? "",
        Email: email ?? "",
        Edad: age ?? "",
        Telefono: phone ?? "",
        Puntaje: score ?? 0,
        FechaInscripcion: date_inscription
          ? new Date(date_inscription).toLocaleString()
          : "",
        AciertosTotales: total_hits ?? 0,
        AciertosParciales: partial_hits ?? 0,
      })
    );

    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // (Opcional) ancho de columnas
    worksheet["!cols"] = [
      { wch: 25 }, // Nombre
      { wch: 15 }, // Cedula
      { wch: 28 }, // Email
      { wch: 8 },  // Edad
      { wch: 18 }, // Telefono
      { wch: 10 }, // Puntaje
      { wch: 22 }, // FechaInscripcion
      { wch: 15 }, // AciertosTotales
      { wch: 18 }, // AciertosParciales
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "users.xlsx");
  };

  return (
    <button
      onClick={exportToExcel}
      className="btn blue-btn btn-ranking"
      style={{ display: "block", width: "auto", margin: "20px 0 20px auto" }}
    >
      Exportar BBDD
    </button>
  );
};

export default ExportUsersButton;
